import { initialSolarPanelSuitabilityCheckFormState } from '@feh/solar-panels-store';

export const mockSolarPanelsSuitabilityCheckViewModel = {
  isVisible: true,
  formState: initialSolarPanelSuitabilityCheckFormState,
  questions: {
    asbestos: false,
    roofType: true,
    renovationDate: false,
  },
  roofMaxAge: NaN,
  criteria: undefined,
  calculationParameters: undefined,
};
